// SparkX AI License Config — Dynamic Gadgets
// এই ফাইলটি সরাসরি .gitignore তে যোগ করুন, public repo তে commit করবেন না।

export const LICENSE_CONFIG = {
  apiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/verify-license',
  apiKey: 'lic_live_867e43425cfad86277d57db8a131851eaeda9e6c1107dbbe',
  domain: 'dynamicgadgets.com.bd',
  supportWhatsApp: '01516585709',
};